import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoaderComponent } from '../../../../../components/ui/loader/loader.component';
import { SelectComponent } from '../../../../../components/forms/select/select.component';
import { Input } from '../../../../../components/forms/input/input';
import { SelectOption } from '../../../../../data/schemas/selectoption.schema';
import { AgentService } from '../../../../../services/agent.service';
import { PosteService } from '../../../../../services/poste.service';
import { StructureService } from '../../../../../services/StructureService';
import { AppService } from '../../../../../core/app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { sexeData } from '../../../../../data/schemas/data/sexe.schema';
import { AgentRes } from '../../../../../data/http/responses/agent.res';
import { PosteRes } from '../../../../../data/http/responses/poste.res';
import { StructureResponse } from '../../../../../data/http/responses/strcuture.res';
import { routeAlias } from '../../../../../../routesalias';
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { RouterLink } from '@angular/router';
// edit.component.ts — imports à ajouter
import { forkJoin } from 'rxjs';


@Component({
  selector: 'app-edit',
  imports: [ReactiveFormsModule, LoaderComponent, SelectComponent, Input, UiButtonComponent, RouterLink],
  templateUrl: './edit.component.html',
  styleUrl: './edit.component.css'
})
export class EditAgentPage implements OnInit {
  entityForm!: FormGroup;
  entityId: string | null = ""
  entityData: any = {}
  public isLoading: boolean = false;
  public structures: SelectOption[] = [];
  public postes: SelectOption[] = [];
  public sexes: SelectOption[] = [];
  public routeAlias = routeAlias;

  constructor(
    private entityService: AgentService,
    private posteService: PosteService,
    private structureService: StructureService,
    private fb: FormBuilder,
    private AppService: AppService,
    private router: Router,
    private route: ActivatedRoute,
  ) {

    this.sexes = sexeData.map((sexe) => ({
      value: sexe.code,
      label: sexe.label
    }))

    this.entityForm = this.fb.group({
      applicationId: this.AppService.getAppId()!,
      strucutre: ['', [Validators.required]],
      poste: ['', [Validators.required]],
      nom: ['', [Validators.required]],
      prenoms: ['', [Validators.required]],
      sexe: [''],
      email: [''],
      adresse: [''],
      telephone: [''],
      emailPro: [''],
      dateNaissance: [''],
      datePriseService: [''],
    });
  }

  // edit.component.ts — remplace ngOnInit + loadStructures + loadPostes + loadEntityById
  ngOnInit(): void {
    this.entityId = this.route.snapshot.paramMap.get('id');
    if (!this.entityId) {
      console.error('Aucun ID d\'agent trouvé dans l\'URL.');
      return;
    }

    this.isLoading = true;

    forkJoin({
      structures: this.structureService.getAllByAppId(this.AppService.getAppId()),
      postes: this.posteService.getAllByAppId(this.AppService.getAppId()!),
      entity: this.entityService.getById(this.entityId),
    }).subscribe({
      next: ({ structures, postes, entity }: any) => {
        this.structures = structures.data.map((item: StructureResponse) => ({
          value: item.id,
          label: item?.libelle
        }));
        this.postes = postes.data.map((item: PosteRes) => ({
          value: item.id,
          label: item?.libelle
        }));
        this.entityData = entity.data;
        this.patchFormWithData(entity.data);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des données d\'édition :', error);
        this.isLoading = false;
      }
    });
  }

  patchFormWithData(data: AgentRes): void {
    this.entityForm.patchValue({
      nom: data.nom,
      prenoms: data.prenoms,
      sexe: data.sexe,
      email: data.email,
      adresse: data.adresse,
      telephone: data.telephone,
      emailPro: data.emailPro,
      dateNaissance: data.dateNaissance,
      datePriseService: data.datePriseService,
      strucutre: data.structure?.id,
      poste: data.poste?.id,
    });
  }

  loadStructures(): void {
    this.isLoading = true
    this.structureService.getAllByAppId(this.AppService.getAppId()).subscribe({
      next: (response: any) => {
        this.structures = response.data.map((item: StructureResponse) => ({
          value: item.id,
          label: item?.libelle
        }));
        this.isLoading = false
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
        this.isLoading = false
      }
    });
  }

  loadPostes(): void {
    this.posteService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.postes = response.data.map((item: PosteRes) => ({
          value: item.id,
          label: item?.libelle
        }));
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  loadEntityById(id: string): void {
    this.entityService.getById(id).subscribe({
      next: (response: any) => {
        //console.log("Données reçues pour l'édition :", response.data)
        this.entityData = response.data
        this.patchFormWithData(response.data)
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement de l\'activité par ID :', error);
        this.isLoading = false;
      }
    })
  }

 

  onEditEntity(): void {
    if (this.entityForm.valid) {
      this.isLoading = true;
      this.entityService.update(this.entityId!, this.entityForm.value).subscribe({
        next: (createdStructure) => {
          this.router.navigate([
            routeAlias.administration.home,
            routeAlias.administration.agent.home,
          ]);
          this.isLoading = false
        },
        error: (error) => {
          console.error('Erreur lors de la création de la structure programmatique :', error);
          this.isLoading = false
        }
      });
    } else {
      console.warn('Le nom de la structure programmatique ne peut pas être vide.');
    }
  }
}
